import React from "react";
import _ from "lodash";

import { Box, InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { withStyles } from "@material-ui/core/styles";

import {
    selectOperatorsSearch,
    setOperatorsSearch,
    OperatorsSearch
} from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";
import { useAppDispatch, useAppSelector } from "store";

const StyledTextField = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main,
        width: theme.spacing(45)
    }
}))(TextField);

const Search = () => {
    const dispatch = useAppDispatch();
    const operatorsSearch = useAppSelector(selectOperatorsSearch);
    const [currentOperatorsSearch, setCurrentOperatorsSearch] = React.useState<OperatorsSearch>(operatorsSearch);

    const setOperatorsSearchDelayed = React.useMemo(() => {
        return _.debounce((operatorsSearch: OperatorsSearch) => dispatch(setOperatorsSearch(operatorsSearch)), 400);
    }, [dispatch]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.value;
        const newOperatorsSearch = { ...operatorsSearch, name };
        setCurrentOperatorsSearch(newOperatorsSearch);
        setOperatorsSearchDelayed(newOperatorsSearch);
    };

    React.useEffect(() => {
        setCurrentOperatorsSearch(operatorsSearch);
    }, [operatorsSearch]);

    return (
        <Box paddingTop={2}>
            <StyledTextField
                placeholder="Search"
                variant="outlined"
                size="small"
                color="secondary"
                value={currentOperatorsSearch.name}
                onChange={handleChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

export default Search;
